<template>
  <span class="wrapper">
    <span class="badge" v-if="show">{{ text }}</span>
    <!-- @slot -->
    <slot />
  </span>
</template>

<script>
/**
 * バッジ
 *
 * slot要素の上に重ねて表示されます
 */
export default {
  name: 'Badge',
  props: {
    /** バッジの表示を制御します */
    show: Boolean,
    /** バッジ内に文字を表示します */
    text: [String, Number],
  },
}
</script>

<style lang="postcss" scoped>
.wrapper {
  display: inline-flex;
  position: relative;
  width: fit-content;
}

.badge {
  align-items: center;
  background-color: var(--pure-red);
  border-radius: 8px;
  box-sizing: border-box;
  color: var(--white);
  display: inline-flex;
  font-size: 10px;
  font-weight: normal;
  height: 16px;
  justify-content: center;
  left: 100%;
  min-width: 16px;
  padding: 0 4px;
  position: absolute;
  transform: translate(-12px, -4px);
  word-break: normal;

  .responsive & {
    @media screen and (--sp-size) {
      line-height: 1.1;
    }
  }
}
</style>
